import Notiflix from "notiflix";
import { useContext, useEffect, useState } from "react";
import { Button, Card, Col, Modal, Offcanvas } from "react-bootstrap";
import { FaListUl, FaLockOpen, FaUserEdit } from "react-icons/fa";
import { FiLogOut } from "react-icons/fi";
import { GiReceiveMoney } from "react-icons/gi";
import { LuIndianRupee } from "react-icons/lu";
import { MdDeleteForever, MdEdit } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
// import { Pagination } from "swiper/modules";
import MaleAvatar from "../../assets/img/maleAvatar.jpg";
// import FemaleAvatar from "../assets/femaleAvatar.jpg";
import { Swiper, SwiperSlide } from "swiper/react";
import AddressBookForm from "../../Address/AddressBookForm";
// import ChangePassword from "../Login/ChangePassword";
// import LogoutModal from "../Login/LogoutModal";
import CustomerOrderList from "../CustomerProfilePage/CustomerOrderList";
import "./CustomerProfilePage.css";
import EditProfile from "./EditProfile";
import { Skeleton } from "antd";
import { newstore } from "../../Components/OnlineOrdering/Home/Pages/Store/newStore";
import PostApiCall from "../../Components/Helpers/PostAPI";
import ModifyQuantity from "../../Components/Buttons/ModifyQuantity";
import NewAddTocart from "../../Components/Buttons/NewAddTocart";
import ChangePassword from "../../Components/ChangePassword";
import LogoutModal from "../../Components/LogoutModal";
// import ProductCard from "../ProductCard/ProductCard";
// import nodata from "../../assets/img/nodata.png";

export default function CustomerProfilePage() {
  const [apiData, setApiData] = useState([]);
  const [customerData, setCustomerData] = useState([]);
  const [addressData, setAddressData] = useState([]);
  const [showCanvas, setShowCanvas] = useState(false);
  const [tempAddData, setTempAddData] = useState([]);
  const [canLogout, setCanLogout] = useState(false);
  const [openChangePwd, setOpenChangePwd] = useState(false);
  const [editCustomerData, setEditCustomerData] = useState(false);
  const [tempCustomerData, setTempCustomerData] = useState([]);
  const [orderHistoryData, setOrderHistoryData] = useState([]);
  const [showDeleteAdd, setShowDeleteAdd] = useState(false);
  const [addToDelete, setAddToDelete] = useState({});
  const { totalOrders, setcart, setLoggedIn, setcartamount, cartItems } =
    useContext(newstore);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    GetProductVertical();
    GetCustomerOrderHistory();
  }, []);
  const GetProductVertical = () => {
    PostApiCall.postRequest(
      {
        stateid: null,
      },
      "Get_All_Items"
    ).then((results) =>
      results.json().then((obj1) => {
        if (results.status === 200 || results.status === 201) {
          console.log(obj1.data.filter((item) => item.fld_status === "Active"))
          setApiData(obj1.data.filter((item) => item.fld_status === "Active"));
        }
      })
    );
  };

  useEffect(() => {
    if (showCanvas !== true) {
      getCustomerAddress();
    }
  }, [showCanvas]);

  const hideDeleteAdd = () => {
    setShowDeleteAdd(false);
  }
  const showDeleteModal = (data) => {
    setShowDeleteAdd(true)
    setAddToDelete(data)
  }
  const handleDeleteAdd = () => {

    Notiflix.Loading.Circle("");

    // Retrieve customer data from local storage
    var customer = localStorage.getItem("CustomerData");
    var CustomerDetails = JSON.parse(customer);

    // Make the delete request
    PostApiCall.postRequest(
      {
        CUSTOMERID: CustomerDetails[0].fld_customerid,
        addressid: addToDelete.fld_address_id,
        title: addToDelete.fld_address_type,
        name: addToDelete.fld_contact_name,
        mobileNo: addToDelete.fld_contact_number,
        area: addToDelete.fld_address_2,
        flatno: addToDelete.fld_address_1,
        landmark: addToDelete.fld_landmark,
        country: addToDelete.Country,
        state: addToDelete.State,
        city: addToDelete.City,
        pincode: addToDelete.fld_pincode,
        action: "DELETE",
      },
      "AddCustomerAddress"
    ).then((results) =>
      results.json().then((obj) => {
        if (results.status === 200 || results.status === 201) {
          // Fetch updated address list
          PostApiCall.postRequest(
            {
              whereClause: `where fld_customerid=${CustomerDetails[0].fld_customerid}`,
            },
            "GetCustomerAddress"
          ).then((results) =>
            results.json().then((obj) => {
              if (results.status === 200 || results.status === 201) {
                setAddressData(obj.data);
                Notiflix.Notify.Success("Address Successfully Deleted.");
                setShowDeleteAdd(false);
                Notiflix.Loading.Remove();
              }
            })
          );
        }
      })
    );
  }

  const handleToggleCanvas = () => {
    setShowCanvas(false);
  };
  useEffect(() => {
    if (editCustomerData != true) {
      GetcustomerDatabyid();
    }
  }, [editCustomerData]);

  const GetCustomerOrderHistory = () => {
    var customer = localStorage.getItem("CustomerData");
    var CustomerDetails = JSON.parse(customer);
    PostApiCall.postRequest(
      {
        WhereClause: `where fld_customer_id=${parseInt(
          CustomerDetails[0].fld_customerid
        )}`,
        select: `*`,
      },
      "GetCustomerOrderDetails"
    ).then((results) =>
      results.json().then((obj) => {
        if (results.status == 200 || results.status == 201) {
          setOrderHistoryData(obj.data);
          Notiflix.Loading.Remove();
        }
      })
    );
  };

  const GetcustomerDatabyid = () => {
    var customer = localStorage.getItem("CustomerData");
    var CustomerDetails = JSON.parse(customer);
    Notiflix.Loading.Circle();
    PostApiCall.postRequest(
      {
        WhereClause: `where fld_customer_id=${CustomerDetails[0].fld_customerid}`,
      },
      "Get_customerData_by_id"
    ).then((results) =>
      results.json().then((obj) => {
        if (results.status === 200 || results.status === 201) {
          setCustomerData(obj.data);
          Notiflix.Loading.Remove();
        }
      })
    );
  };

  function getCustomerAddress() {
    var customer = localStorage.getItem("CustomerData");
    var CustomerDetails = JSON.parse(customer);
    Notiflix.Loading.Circle();
    PostApiCall.postRequest(
      {
        whereClause: `where fld_customerid=${CustomerDetails[0].fld_customerid}`,
      },
      "GetCustomerAddress"
    ).then((results) =>
      results.json().then((obj) => {
        if (results.status === 200 || results.status === 201) {
          setAddressData(obj.data);
          Notiflix.Loading.Remove();
        }
      })
    );
  }
  const onLogout = () => {
    if (localStorage.getItem("CustomerData") !== null) {
      localStorage.removeItem("CustomerData");
      localStorage.removeItem("OrderData");
      setcart(0);
      setcartamount(0);
      navigate("/");
      setLoggedIn(false);
      setCanLogout(false);
      Notiflix.Loading.Remove();
    } else {
      Notiflix.Notify.Failure("Something went wrong");
    }
  };
  const handleTogglePwdModal = () => {
    setOpenChangePwd(false);
  };
  const handleToggleCustomerProfile = () => {
    setEditCustomerData(false);
  };
  const handleToggleLogout = () => {
    setCanLogout(false);
  };

  return (
    <>
      <ChangePassword
        isOpen={openChangePwd}
        handdleToggleModal={handleTogglePwdModal}
      />
      <LogoutModal
        show={canLogout}
        onHide={handleToggleLogout}
        onLogout={onLogout}
      />
      <div className="container-fluid my-5 blogcontainer">
        <section className="section-spacing-x section-spacing-x-mobile py-4 spacing">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-4">
                <div className="profile-card">
                  {customerData.length > 0 ? (
                    <>
                      {customerData[0]?.fld_created_on && (
                        <div className="d-flex pb-0 justify-content-end">
                          <p className="mb-2">
                            Customer Since: {customerData[0]?.fld_created_on}
                          </p>
                        </div>
                      )}
                    </>
                  ) : (
                    <>
                      <div className="d-flex pb-0 justify-content-end">
                        <p className="mb-0">
                          <Skeleton.Input />
                        </p>
                      </div>
                    </>
                  )}
                  <div className="d-lg-flex pt-0">
                    {customerData.length > 0 ? (
                      <div className="img">
                        {/* {customerData[0]?.fld_gender === "Male" && ( */}
                        <img src={MaleAvatar} className="img-fluid" alt="MaleAvatar" />
                        {/* )} */}
                        {/* {customerData[0]?.fld_gender === "Female" && (
                        <img src={FemaleAvatar} className="img-fluid" alt="FemaleAvatar" />
                      )} */}
                      </div>
                    ) : (
                      <div className="img">
                        <Skeleton.Image className="img-fluid" alt="" />
                      </div>
                    )}
                    {customerData.length > 0 ? (
                      <div className="content mb-lg-0 mb-3">
                        <div className="fields">
                          <lable>Name</lable>
                          <p>{customerData[0]?.fld_name}</p>
                        </div>
                        {customerData[0]?.fld_dateofbirth && (
                          <div className="fields">
                            <lable>Date of Birth</lable>
                            <p>{customerData[0]?.fld_name}</p>
                          </div>
                        )}
                        <div className="fields">
                          <lable>Email</lable>
                          <p>{customerData[0]?.fld_email_address}</p>
                        </div>
                      </div>
                    ) : (
                      <div className="content">
                        <div className="fields">
                          <lable>
                            <Skeleton.Input />
                          </lable>
                          <p>
                            <Skeleton.Input />
                          </p>
                        </div>
                        <div className="fields">
                          <lable>
                            <Skeleton.Input />
                          </lable>
                          <p>
                            <Skeleton.Input />
                          </p>
                        </div>
                        <div className="fields">
                          <lable>
                            <Skeleton.Input />
                          </lable>
                          <p>
                            <Skeleton.Input />
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="btns">
                    <button
                      onClick={() => {
                        setEditCustomerData(true);
                        setTempCustomerData(customerData);
                      }}
                    >
                      <FaUserEdit /> Edit
                    </button>
                    <button onClick={() => setOpenChangePwd(true)}>
                      <FaLockOpen /> Change Password
                    </button>
                    <button onClick={() => setCanLogout(true)}>
                      <FiLogOut /> Logout
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-lg-8">
                {customerData.length > 0 ? (
                  <div className="row h-100">
                    <div className="col-lg-6 my-4 my-lg-0">
                      <div className="four-card">
                        <div className="head">
                          <div className="icon">
                            <FaListUl />
                          </div>
                          <h2 className="main-heading mb-0">Orders</h2>
                        </div>
                        <div className="fields">
                          <lable>No. of Orders:</lable>
                          <p>{orderHistoryData.length ? orderHistoryData[0].total_order : 0}</p>
                          {/* <p>{totalOrders ? totalOrders.total_order : 0}</p> */}
                        </div>
                        {/* {totalOrders && ( */}
                        <div className="fields">
                          <lable>Last Ordered on:</lable>
                          {/* <p>{totalOrders?.fld_order_date}</p> */}
                          <p>{orderHistoryData.length ? orderHistoryData[orderHistoryData.length - 1].fld_order_date : ""}</p>
                        </div>
                        {/* )} */}
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="four-card">
                        <div className="head">
                          <div className="icon">
                            <GiReceiveMoney />
                          </div>
                          <h2 className="main-heading mb-0"> My Savings</h2>
                        </div>
                        <div className="fields">
                          <lable>Spent: </lable>
                          <p>
                            <LuIndianRupee />{" "}
                            {totalOrders
                              ? parseFloat(totalOrders?.TotalSalesValue).toFixed(
                                2
                              )
                              : 0}
                          </p>
                        </div>
                        <div className="fields">
                          <lable>Saved: </lable>
                          <p>
                            <LuIndianRupee />{" "}
                            {totalOrders
                              ? parseFloat(totalOrders?.total_discount).toFixed(2)
                              : 0}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="row h-100">
                    <div className="col-lg-6 my-4 my-lg-0">
                      <div className="four-card">
                        <div className="head">
                          <div className="icon"></div>
                          <h2 className="main-heading mb-0">
                            <Skeleton.Input />
                          </h2>
                        </div>
                        <div className="fields">
                          <lable>
                            <Skeleton.Input />
                          </lable>
                          <p>
                            <Skeleton.Input />
                          </p>
                        </div>
                        <div className="fields">
                          <lable>
                            <Skeleton.Input />
                          </lable>
                          <p>
                            <Skeleton.Input />
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="four-card">
                        <div className="head">
                          <div className="icon">{/* <GiReceiveMoney /> */}</div>
                          <h2 className="main-heading mb-0">
                            <Skeleton.Input />
                          </h2>
                        </div>
                        <div className="fields">
                          <lable>
                            <Skeleton.Input />{" "}
                          </lable>
                          <p>
                            <Skeleton.Input />
                          </p>
                        </div>
                        <div className="fields">
                          <lable>
                            <Skeleton.Input />{" "}
                          </lable>
                          <p>
                            <Skeleton.Input />
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <CustomerOrderList orderHistoryData={orderHistoryData} />

              {/* Address Listing */}
              <div className="col-12 mb-4">
                <div className="d-flex justify-content-between mb-4 align-items-end">
                  <h2 className="mb-0">Address</h2>
                  <Button
                    variant="danger"
                    size="lg"
                    className=" mb-3 "
                    onClick={() => setShowCanvas(true)}>
                    Add Address
                  </Button>
                </div>
                <div>
                  {addressData.length === 0 ? (
                    <div className="w-100 text-center">
                      {/* <img className="nodata-icon" src={nodata} /> */}
                      <h4 className="text-center my-2">Address not found</h4>
                    </div>
                  ) : (
                    <Swiper
                      slidesPerView={1}
                      spaceBetween={10}
                      pagination={{
                        clickable: true,
                      }}
                      breakpoints={{
                        640: {
                          slidesPerView: 1,
                          spaceBetween: 20,
                        },
                        768: {
                          slidesPerView: 3,
                          spaceBetween: 20,
                        },
                        1024: {
                          slidesPerView: 4,
                          spaceBetween: 20,
                        },
                      }}
                      // modules={[Pagination]}
                      className="mySwiper"
                    >
                      {addressData.map((address, index) => {
                        return (
                          <SwiperSlide>
                            <div
                              key={index}
                              className="address-card position-relative"
                            >
                              <p>
                                {address.fld_address_1}, {address.fld_address_2},{" "}
                                <br />
                                {address.CityName}, {address.StateName} <br />{" "}
                                {address.fld_pincode}, {address.CountryName}
                              </p>
                              <p>{address.fld_landmark}</p>
                              <div className="add-edit-del-btns">
                                <span
                                  onClick={() => {
                                    setTempAddData(address);
                                    setShowCanvas(true);
                                  }}
                                >
                                  <MdEdit />
                                </span>
                                <span onClick={() => showDeleteModal(address)}>
                                  <MdDeleteForever />
                                </span>
                              </div>
                            </div>
                          </SwiperSlide>
                        );
                      })}
                    </Swiper>
                  )}
                </div>
              </div>

              {/* FBI listing */}
              <div className="col-12 mb-4">
                {orderHistoryData.length !== 0 && (
                  <div className="col-12 mb-4">
                    <h2 className="mb-4">Frequently Bought Items</h2>
                    <Swiper
                      slidesPerView={1}
                      spaceBetween={10}
                      pagination={{
                        clickable: true,
                      }}
                      breakpoints={{
                        640: {
                          slidesPerView: 1,
                          spaceBetween: 20,
                        },
                        768: {
                          slidesPerView: 3,
                          spaceBetween: 20,
                        },
                        1024: {
                          slidesPerView: 4,
                          spaceBetween: 20,
                        },
                      }}
                      // modules={[Pagination]}
                      className="mySwiper"
                    >
                      {apiData.map((item) => {
                        const isCart = cartItems.find((val) => {
                          if (val.fld_variantid === item.fld_variantid) {
                            return item;
                          }
                          return false;
                        });
                        return (
                          <SwiperSlide>
                            <div
                              key={item.fld_variantid}
                              className="frequently-card"
                            >
                              <Col xs={12} md={12} className="mt-3">
                                <Card>
                                  <Link to={`/product/${item.fld_route}`}>
                                    <Card.Img variant="top" src={item.VariantImage} />
                                  </Link>
                                  <Card.Body>
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                      <Card.Title className="mb-0">{item.fld_variantname}</Card.Title>
                                    </div>
                                  </Card.Body>
                                  <Card.Footer>
                                    <div className="d-flex align-items-center justify-content-between">
                                      <Card.Text className="mb-0">₹{item.fld_website_discount_price}</Card.Text>
                                      {isCart ? (
                                        <ModifyQuantity
                                          itemid={item?.fld_variantid}
                                          quantity={isCart.fld_quantity}
                                          cartlineid={isCart.fld_cart_dtl_id}
                                        />
                                      ) : (
                                        <span className="theme-btn cursor-pointer">
                                          <NewAddTocart itemid={item?.fld_variantid} />
                                        </span>
                                      )}
                                    </div>
                                  </Card.Footer>
                                </Card>
                              </Col>
                            </div>
                          </SwiperSlide>
                        );
                      })}
                    </Swiper>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
      <Offcanvas
        show={showCanvas}
        onHide={handleToggleCanvas}
        className="address-offcanvas"
        id="offcanvasNavbar-expand-lg"
        aria-labelledby="offcanvasNavbarLabel-expand-sm"
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <h4 className="section-title-category-section mt-0">
            Add New Address
          </h4>
          {/* <img src={logo} className="img-fluid nav-logo" /> */}
        </Offcanvas.Header>
        <Offcanvas.Body className="pt-0">
          <AddressBookForm
            toggleCanvas={handleToggleCanvas}
            address={tempAddData}
          />
        </Offcanvas.Body>
      </Offcanvas>

      {/* Canvas to edit profile data */}
      <Offcanvas
        show={editCustomerData}
        onHide={handleToggleCustomerProfile}
        className="address-offcanvas"
        id="offcanvasNavbar-expand-lg"
        aria-labelledby="offcanvasNavbarLabel-expand-sm"
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <h4 className="section-title-category-section mt-0">Edit Profile</h4>
          {/* <img src={logo} className="img-fluid nav-logo" /> */}
        </Offcanvas.Header>
        <Offcanvas.Body className="pt-0">
          <EditProfile
            toggleCanvas={handleToggleCustomerProfile}
            customerData={tempCustomerData}
          />
        </Offcanvas.Body>
      </Offcanvas>
      <Modal centered show={showDeleteAdd} onHide={hideDeleteAdd}>
        <Modal.Header closeButton className="border-0 pb-0"></Modal.Header>
        <Modal.Body className="pt-0">
          <div className="login-box pt-3 pb-0">
            {/* <div className="login-modal-icon">
              <LuLogOut />
            </div> */}
            <div className="section-title mb-0 mt-0">
              <h4 className="text-center">Delete address</h4>
            </div>
            <p style={{ textAlign: "center", marginTop: "-10px" }}>
              Are you sure you want to Delete Address?
            </p>

            <div className="text-center d-flex gap-3 justify-content-center">
              <Button
                variant="danger"
                size="lg"
                className="w-100 mb-3 "
                onClick={handleDeleteAdd}>
                Yes
              </Button>
              <Button
                variant="danger"
                size="lg"
                className="w-100 mb-3 "
                onClick={hideDeleteAdd}>
                Cancel
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
